import { motion } from 'framer-motion';
import { FaBookOpen, FaBullseye, FaHandshake, FaLightbulb, FaStar, FaUsers } from 'react-icons/fa';
import { GoGoal } from 'react-icons/go';
import HpeGolden from '../../assets/acknowledgements/hpe-golden.png';
import HpeSilver from '../../assets/acknowledgements/hpe-silver.png';
import NvidiaReconhecimento from '../../assets/acknowledgements/nvidia.png';
import VmwareReconhecimento from '../../assets/acknowledgements/vmware.jpg';
import CertigovIcon from '../../assets/images/certigov.png';
import CorpTeam from '../../assets/images/corp-team.jpg';
import { MethodologyCircle } from '../../components/MethodologyCircle/MethodologyCircle';
import Section from '../../components/Section/Section';
import styles from './About.module.scss';

export default function About() {
    const recognitions = [
        {
            title: 'Selo Certigov',
            image: CertigovIcon,
            alt: 'Selo Bronze Certigov Decatron',
        },
        {
            title: 'HPE Gold Services Provider',
            image: HpeGolden,
            alt: 'HPE Gold Services Provider Badge',
        },
        {
            title: 'O Maior Solution Provider da HPE em 2020',
            image: HpeSilver,
            alt: 'HPE Silver Solution Provider Badge 2020',
        },
        {
            title: 'Destaque Solution Provider NVIDIA em 2020',
            image: NvidiaReconhecimento,
            alt: 'NVIDIA Preferred Partner Badge 2020',
        },
        {
            title: 'VMware Principal Partner',
            image: VmwareReconhecimento,
            alt: 'VMware Principal Partner Cloud Provider',
        },
    ];

    const values = [
        {
            icon: FaHandshake,
            title: 'Ética',
            description: 'Conduta íntegra e transparente em todas as nossas relações',
        },
        {
            icon: FaUsers,
            title: 'Compromisso',
            description: 'Dedicação total aos resultados dos nossos clientes e parceiros',
        },
        {
            icon: FaBullseye,
            title: 'Disciplina',
            description: 'Processos estruturados e metodologias comprovadas',
        },
        {
            icon: FaLightbulb,
            title: 'Inovação',
            description: 'Soluções criativas e tecnologias de ponta',
        },
    ];

    return (
        <div className={styles.container}>
            {/* Nossa História */}
            <Section background="gradient" className={styles.historySection}>
                <div className={styles.section_content}>
                    <div className={styles.text_content}>
                        <motion.div
                            initial={{ opacity: 0, x: -30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8 }}
                            viewport={{ once: true }}
                        >
                            <FaBookOpen className={styles.section_icon} />
                            <h2 className={styles.section_title}>Nossa História</h2>
                            <p className={styles.section_text}>
                                Há mais de três décadas, a Decatron nasceu com o propósito de
                                transformar desafios tecnológicos em oportunidades de crescimento.
                                Desde então, temos evoluído continuamente, ampliando nosso portfólio
                                e adaptando nossas soluções às necessidades de cada cliente.
                            </p>
                            <p className={styles.section_text}>
                                Ao longo dessa trajetória, combinamos expertise em gestão de ativos
                                e segurança da informação com espírito inovador, construindo
                                projetos que unem eficiência operacional e proteção digital.
                            </p>
                            <p className={styles.section_text}>
                                Nossa experiência consolidada é fruto de um trabalho colaborativo
                                com organizações de diversos segmentos, sempre guiado pelo
                                compromisso com resultados concretos e relações de longo prazo
                                baseadas na confiança mútua.
                            </p>
                        </motion.div>
                    </div>
                    <div className={styles.image_content}>
                        <motion.img
                            src={CorpTeam}
                            alt="Equipe Corporativa Decatron"
                            className={styles.section_image}
                            initial={{ opacity: 0, x: 30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8 }}
                            viewport={{ once: true }}
                        />
                    </div>
                </div>
            </Section>

            {/* Diferencial Competitivo */}
            <Section background="white" className={styles.diferencial_section}>
                <div className={styles.diferencial_container}>
                    <motion.div
                        className={styles.diferencial_content}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                    >
                        <h2 className={styles.diferencial_title}>O que nos diferencia</h2>
                        <p className={styles.diferencial_subtitle}>
                            Nossa experiência e expertise nos tornam únicos no mercado
                        </p>

                        <div className={styles.diferencial_grid}>
                            <div className={styles.diferencial_item}>
                                <h3 className={styles.diferencial_item_title}>
                                    Experiência Consolidada
                                </h3>
                                <p className={styles.diferencial_item_text}>
                                    Mais de 30 anos atuando no mercado de tecnologia, com projetos
                                    de alta complexidade em diversos segmentos.
                                </p>
                            </div>
                            <div className={styles.diferencial_item}>
                                <h3 className={styles.diferencial_item_title}>
                                    Parcerias Estratégicas
                                </h3>
                                <p className={styles.diferencial_item_text}>
                                    Certificações e parcerias com os principais players do mercado
                                    tecnológico mundial.
                                </p>
                            </div>
                            <div className={styles.diferencial_item}>
                                <h3 className={styles.diferencial_item_title}>
                                    Abordagem Consultiva
                                </h3>
                                <p className={styles.diferencial_item_text}>
                                    Entendemos profundamente o negócio do cliente antes de propor
                                    qualquer solução tecnológica.
                                </p>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </Section>

            {/* Propósito e Valores */}
            <Section background="white" className={styles.proposito_section}>
                <div className={styles.section_header}>
                    <GoGoal className={styles.section_icon} />
                    <h2 className={styles.section_title}>Nosso Propósito</h2>
                    <p className={styles.section_subtitle}>
                        Conectar Pessoas e Negócios através de Soluções Tecnológicas Inteligentes
                    </p>
                </div>

                <div className={styles.proposito_content}>
                    <p className={styles.proposito_text}>
                        Somos uma empresa de Soluções que utiliza a Tecnologia e a Experiência de
                        nosso Time e de nossos Parceiros, para viabilizar os Projetos dos nossos
                        Clientes, buscando entender suas necessidades e superar suas expectativas.
                    </p>
                </div>

                <div className={styles.valores_grid}>
                    <h3 className={styles.valores_title}>Nossos Valores</h3>
                    <div className={styles.valores_cards}>
                        {values.map((value, index) => (
                            <motion.div
                                key={index}
                                className={styles.valor_card}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: index * 0.1 }}
                                viewport={{ once: true }}
                            >
                                <value.icon className={styles.valor_icon} />
                                <h4 className={styles.valor_title}>{value.title}</h4>
                                <p className={styles.valor_description}>{value.description}</p>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </Section>

            {/* Reconhecimentos */}
            <Section background="gradient" className={styles.reconhecimentos_section}>
                <div className={styles.section_header}>
                    <FaStar className={styles.section_icon} />
                    <h2 className={styles.section_title}>Reconhecimentos</h2>
                    <p className={styles.section_subtitle}>
                        O compromisso com a qualidade e a alta performance dos resultados está
                        diretamente relacionado aos selos e prêmios que recebemos
                    </p>
                </div>

                <div className={styles.badges_container}>
                    {recognitions.map((item, index) => (
                        <motion.div
                            key={index}
                            className={styles.badge_item}
                            initial={{ opacity: 0, scale: 0.8 }}
                            whileInView={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.5, delay: index * 0.1 }}
                            viewport={{ once: true }}
                            whileHover={{ scale: 1.05 }}
                        >
                            <div className={styles.badge_icon}>
                                <FaStar />
                            </div>
                            <h3 className={styles.badge_title}>{item.title}</h3>
                            <div className={styles.badge_decoration}></div>
                        </motion.div>
                    ))}
                </div>
            </Section>

            {/* Metodologia */}
            <Section background="white" className={styles.metodologia_section}>
                <div className={styles.metodologia_container}>
                    <motion.h2
                        className={styles.metodologia_title}
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                    >
                        Metodologia
                    </motion.h2>
                    <div className={styles.circle_container}>
                        <MethodologyCircle />
                    </div>
                </div>
            </Section>
        </div>
    );
}
